export const fmtN = (n) => new Intl.NumberFormat("id-ID").format(n ?? 0);
export const fmtPct = (p) => `${((p ?? 0) * 100).toFixed(1)}%`;

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return (
    d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }) +
    " · " +
    d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })
  );
}
